


































import {
    computed,
    defineComponent,
} from '@vue/composition-api';

import { SdsTooltip } from '@superbet-group/web.lib.ui-components';
import { useTooltipManager } from './TooltipManager';

export default defineComponent({
    name: 'SdsTooltipOverlay',
    setup() {
        const { tooltipProps } = useTooltipManager();

        const isTooltipVisible = computed(() => !!tooltipProps.value?.text);

        const styles = computed(() => {
            if (!tooltipProps.value) {
                return {};
            }

            return {
                top: toPx(tooltipProps.value.top),
                right: toPx(tooltipProps.value.right),
                bottom: toPx(tooltipProps.value.bottom),
                left: toPx(tooltipProps.value.left),
                transform: tooltipProps.value.transform,
            };
        });

        const variant = computed(() => tooltipProps.value?.variant);
        const direction = computed(() => tooltipProps.value?.direction);
        const text = computed(() => tooltipProps.value?.text);
        const isHtml = computed(() => tooltipProps.value?.isHtml);
        const isRaw = computed(() => tooltipProps.value?.isRaw);
        const hotkey = computed(() => tooltipProps.value?.hotkey);

        function toPx(value: number | undefined): string | undefined {
            return value != null ? `${value}px` : undefined;
        }

        return {
            isTooltipVisible,
            variant,
            direction,
            text,
            isHtml,
            isRaw,
            hotkey,
            styles,
        };
    },
    components: {
        SdsTooltip,
    },
});
